export default __webpack_public_path__ + "static/media/54t.32240f7a.jpg";